import React from "react";
import { Phone, Mail, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function CommencezVotreProjet() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="44045" id="prêt-à-déléguer" className="dark bg-primary py-24 px-6 md:px-8 text-primary-foreground">
      <div ref={ref} className={cn("max-w-4xl mx-auto text-center transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h2 className="text-4xl md:text-5xl font-serif font-semibold text-primary-foreground mb-6 tracking-tight">Prêt à sécuriser et maximiser vos revenus locatifs ?</h2>
        
        <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto leading-relaxed font-default">
          Confiez la gestion de votre propriété à D Location. Nous optimisons vos rendements à Nice tout en prenant soin de chaque détail pour vous et vos voyageurs, avec une expertise locale inégalée.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
          <Link to="tel:+33493123456" className="group flex items-center gap-3 text-xl font-semibold text-accent hover:text-accent/80 transition-colors">
            <span className="p-3 rounded-lg bg-accent/10 group-hover:bg-accent/20 transition-all shadow-sm hover:shadow-md">
              <Phone className="w-6 h-6" />
            </span>
            <span className="font-default">+33 6 45 66 56 57</span>
          </Link>

          <Link to="mailto:contact@d-location-nice.fr" className="group flex items-center gap-3 text-xl font-semibold text-accent hover:text-accent/80 transition-colors">
            <span className="p-3 rounded-lg bg-accent/10 group-hover:bg-accent/20 transition-all shadow-sm hover:shadow-md">
              <Mail className="w-6 h-6" />
            </span>
            <span className="font-default">dlocation.admin@gmail.com</span>
          </Link>
        </div>

        <div className="mt-12">
          <p className="text-sm text-muted-foreground mb-4 font-default">
            Votre sérénité et la rentabilité de votre bien commencent par une simple conversation.
          </p>
        </div>
      </div>
    </section>;
}